export const formatPrice = (priceInHundreds: number) => {
  const price = priceInHundreds / 100;
  const outputPrice = price % 1 === 0 ? price : price.toFixed(2).replace(".", ",");
  return String(outputPrice);
};
